import { Box, Paper, Typography } from "@mui/material";
import { ReferralProgram } from "../types/view.referral";
import { formatCurrency } from "../utils/formatters";

interface Props {
  data: ReferralProgram;
}

export default function CommissionCard({ data }: Props) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "24px",
        p: 2.5,
        backgroundColor: "#fff",
        minHeight: 280,
      }}
    >
      <Typography sx={{ fontSize: "1rem", fontWeight: 600, mb: 3 }}>
        Commission
      </Typography>

      <Box
        sx={{
          mx: "auto",
          maxWidth: 280,
          textAlign: "center",
          border: "1px solid #D6DCE5",
          borderRadius: "16px",
          py: 1.5,
          mb: 2.5,
          backgroundColor: "#F8FAFC",
        }}
      >
        <Typography sx={{ fontSize: "0.7rem", color: "#4A4A4A" }}>
          PENDING BALANCE
        </Typography>
        <Typography
          sx={{ fontSize: "1rem", fontWeight: 700, color: "#4A4A4A" }}
        >
          {formatCurrency(data.pending_balance)}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 4 }}>
        <Box sx={{ textAlign: "center", flex: 1 }}>
          <Typography sx={{ fontWeight: 600 }}>
            {formatCurrency(data.this_month)}
          </Typography>
          <Typography sx={{ fontSize: "0.82rem" }}>This Month</Typography>
        </Box>

        <Box sx={{ textAlign: "center", flex: 1 }}>
          <Typography sx={{ fontWeight: 600 }}>
            {formatCurrency(data.last_month)}
          </Typography>
          <Typography sx={{ fontSize: "0.82rem" }}>Last Month</Typography>
        </Box>

        <Box sx={{ textAlign: "center", flex: 1 }}>
          <Typography sx={{ fontWeight: 600 }}>
            {formatCurrency(data.all_time)}
          </Typography>
          <Typography sx={{ fontSize: "0.82rem" }}>All Time</Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, height: 74 }}>
        {[18, 15, 48, 64, 40, 28].map((h, i) => (
          <Box
            key={i}
            sx={{
              flex: 1,
              height: h,
              borderRadius: "999px",
              backgroundColor: "#D7D7D7",
            }}
          />
        ))}
      </Box>
    </Paper>
  );
}
